/**
 * Map old Taskydo pharma URLs onto the Curedia app, and choose which
 * nav entries a product shell shows.
 *
 * Chat and business are universal on Taskydo and Curedia. Pharma is
 * Curedia. Letswebinar is its own shell and does not use this nav.
 */

export function curediaPathFromLegacy(path) {
  if (typeof path !== 'string' || !path) return '/';
  const query = path.includes('?') ? `?${path.split('?').slice(1).join('?')}` : '';
  const raw = path.split('?')[0];
  if (raw === '/pharma' || raw === '/pharma/') return `/${query}`;
  if (raw.startsWith('/pharma/')) return `${raw.slice('/pharma'.length)}${query}`;
  return path;
}

function remapEntry(entry) {
  if (!entry || typeof entry !== 'object') return entry;
  const next = { ...entry };
  if (typeof next.to === 'string') next.to = curediaPathFromLegacy(next.to);
  if (typeof next.home === 'string') next.home = curediaPathFromLegacy(next.home);
  if (next.urlPrefix === '/pharma') next.urlPrefix = '';
  else if (typeof next.urlPrefix === 'string') {
    next.urlPrefix = curediaPathFromLegacy(next.urlPrefix);
  }
  if (Array.isArray(next.children)) next.children = next.children.map(remapEntry);
  return next;
}

export function navForProduct(nav, productKey) {
  const key = productKey || 'taskydo';
  const visible = (nav || []).filter((app) => {
    if (key === 'letswebinar') return false;
    if (app.appKey === 'webinar' || app.appKey === 'successyatra') return false;
    if (key === 'curedia') {
      return app.appKey === 'pharma' || app.appKey === 'chat' || app.appKey === 'business';
    }
    return app.appKey !== 'pharma';
  }).map((app) => (key === 'curedia' ? remapEntry(app) : app));
  if (key !== 'curedia') return visible;
  // Pharma is the Curedia home. Chat and business stay available after it.
  return [...visible].sort((a, b) => {
    if (a.appKey === 'pharma') return -1;
    if (b.appKey === 'pharma') return 1;
    return 0;
  });
}

export function entryMatchesPath(entry, pathname) {
  if (!entry || !pathname) return false;
  const to = entry.to;
  if (to && to !== '/') {
    if (pathname === to || pathname.startsWith(`${to}/`)) return true;
  } else if (to === '/' && pathname === '/') {
    return true;
  }
  return (entry.children || []).some((child) => entryMatchesPath(child, pathname));
}
